import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import geosetka from '../Images/sp_glasphalt_carbophalt_g.jpg';

const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(11),
    paddingBottom: theme.spacing(11),
  },
  card: {
    display: 'flex',
    minWidth: 275,
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
}));
const Product = () => {
  const classes = useStyles();

  return (
    <Grid item key="rainfocmentG" xs={12} sm={6}>
      <Card sm={6} className={classes.card}>
        <CardMedia
          className={classes.cardMedia}
          image={geosetka}
          title="geosetka GV"
        />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="h5" component="h2">
            Геосетка S&P <span>Glasphalt GV</span>
          </Typography>

          <Typography>
            120/120 kN/m (при удлинении 3%)
            <br /> Геосетка с предварительной битумной пропиткой для упрочнения
            асфальтовых покрытий. Сертифицирован по РФ.
          </Typography>
        </CardContent>
        <CardActions>
          <Link to="/product">Узнать больше</Link>
        </CardActions>
      </Card>
    </Grid>
  );
};
export default Product;
